function possuiMinimoPalavras(texto, minimo) {
  return texto.trim().split(/\s+/).filter(Boolean).length >= minimo;
}

export { possuiMinimoPalavras };
